import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Container, Content, Title } from './section.styles';
import { renderWhenNotNil } from '../../utils/rendering';

export class Section extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    children: PropTypes.any,
    className: PropTypes.any,
    contentStyles: PropTypes.any,
  };

  render() {
    return (
      <Container className={this.props.className}>
        {renderWhenNotNil(() => <Title>{this.props.title}</Title>)(this.props.title)}
        <Content extraStyles={this.props.contentStyles}>{this.props.children}</Content>
      </Container>
    );
  }
}
